import { FC } from 'react';
import { Button, TextField } from '@mui/material';
import { Field, Form, Formik } from 'formik';
import { CustomSelectFormik } from 'components/elements';
import { IOption } from 'components/elements/CustomSelect';
import { ICityAliasFormValues } from 'types';
import { CityAutocompleteField } from '../CityAutocompleteField';
import s from './index.module.scss';

interface CityAliasFormProps {
	buttonText: string;
	initialValues: ICityAliasFormValues;
	onSubmit: (values: ICityAliasFormValues) => void;
	cityOptions: IOption[];
	cityOptionsLoading: boolean;
	onCitySearch: (search: string) => void;
	onCityLoadMore: () => void;
	hasMoreCityOptions: boolean;
	initialCityTitle?: string;
	providerOptions: IOption[];
	onDeleteRequest?: () => void;
	canDelete?: boolean;
}

export const CityAliasForm: FC<CityAliasFormProps> = ({
	buttonText,
	initialValues,
	onSubmit,
	cityOptions,
	cityOptionsLoading,
	onCitySearch,
	onCityLoadMore,
	hasMoreCityOptions,
	initialCityTitle = '',
	providerOptions,
}) => {
	return (
		<Formik initialValues={initialValues} onSubmit={onSubmit}>
			{({ values, dirty, setFieldValue }) => {
				const isSubmitDisabled = !values.name.trim() || !values.cityId || !values.providerId || !dirty;

				return (
					<Form className={s.form}>
						<Field label="Аліас міста" name="name" variant="outlined" as={TextField} fullWidth />
						<CityAutocompleteField
							cityOptions={cityOptions}
							cityOptionsLoading={cityOptionsLoading}
							hasMoreCityOptions={hasMoreCityOptions}
							initialCityTitle={initialCityTitle}
							onCityLoadMore={onCityLoadMore}
							onCitySearch={onCitySearch}
							onChange={(cityId) => setFieldValue('cityId', cityId)}
							value={values.cityId}
						/>
						<Field label="Провайдер" name="providerId" options={providerOptions} component={CustomSelectFormik} />

						<div className={s.actions}>
							<Button type="submit" disabled={isSubmitDisabled} variant="rounded">
								{buttonText}
							</Button>
						</div>
					</Form>
				);
			}}
		</Formik>
	);
};
